import { render, staticRenderFns } from "./news2.vue?vue&type=template&id=02df61c6&scoped=true"
import script from "./news2.vue?vue&type=script&lang=ts"
export * from "./news2.vue?vue&type=script&lang=ts"
import style0 from "./news2.vue?vue&type=style&index=0&id=02df61c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02df61c6",
  null
  
)

export default component.exports